// extracted by mini-css-extract-plugin
export var orderSummary = "_ty-0";
export var showMoreLessButton = "_ty-1";